import Button from 'beam/dist/Button'
import { Dialog, DialogActions, DialogContent, DialogTitle } from 'beam/dist/Dialog'
import { LinearProgress } from 'beam/dist/Progress'
import { ReactElement, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import PasswordApi from '../Password/password.api'
import { AuthLayout } from '../../Common/AuthLayout'
import { logout } from '../LegacyLogin/login.actions'
import { resetPassword, validateUuid } from './api'
import ResetPasswordForm from './ResetPasswordForm'
import { useTranslation } from 'react-i18next'

interface ResetPasswordProps {
  history: { push: $TSFIXME },
  logout: () => $TSFIXME,
  match: { params: { uuid: string } },
}

const ResetPassword = ({ history, logout, match }: ResetPasswordProps): ReactElement => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)
  const [isUuidValid, setIsUuidValid] = useState(false)
  const [isPassUpdated, setIsPassUpdated] = useState(false)

  useEffect(() => {
    logoutAndConfirmUuid()
  }, [isPassUpdated])

  const logoutAndConfirmUuid = async (): Promise<void> => {
    setIsLoading(true)
    setIsUuidValid(false)
    try {
      await Promise.all([validateUuid(match.params.uuid), logout()])
      setIsUuidValid(true)
    } catch (e) {
      setIsUuidValid(false)
    } finally {
      setIsPassUpdated(true)
      setIsLoading(false)
    }
  }

  const goToRoot = (): void => history.push('/')

  return (
    isLoading ?
      <LinearProgress color="secondary" /> :
      <AuthLayout>
        {!isUuidValid && (
          <Dialog open>
            <DialogTitle>{t('pwdResetErrorTitle')}</DialogTitle>
            <DialogContent>{t('pwdResetErrorBody')}</DialogContent>
            <DialogActions>
              <Button onClick={goToRoot}>{t('ok')}</Button>
            </DialogActions>
          </Dialog>
        )}
        <ResetPasswordForm
          uuid={match.params.uuid}
          checkPasswordStrength={PasswordApi.checkPasswordStrength}
          resetPassword={resetPassword}
          onReset={goToRoot}
        />
      </AuthLayout>
  )
}

const mapStateToProps = null

const mapDispatchToProps = ({
  logout,
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(ResetPassword)
